<div class="loader-overlay">
<div class="spinner spinner-container">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
    <div class="rect6"></div>
    <div class="rect7"></div>
    <div class="rect8"></div>
    <div class="rect9"></div>
    <div class="rect10"></div>
  </div>
  <div *ngIf="message != undefined && message != null && message != ''" class="loader-message-div">{{message}}</div>
</div>